<template>
  <v-app id="peer-group-app">
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col
                v-for="facet in SearchFacets"
                cols="12"
                :key="facet.identifier"
                sm="4"
                md="2"
style="margin:0;margin-left:10px;"
              >
                <h6>{{ facet.title }}</h6>
                <template v-if="facet.type === 'number_range'">
                  <v-row style="margin:0;">
                    <v-col
v-for="option in facet.data"
                           cols="12"
:key="option.id"
>
                      <v-row
justify="space-between"
                             align="center"
>
                        <v-col cols="10">
                          <v-switch
                            v-model="option.selected"
                            :label="option.description"
                            :title="option.description"
                            hide-details
                            @click="AddRemoveFilterOption(option,facet)"
                          />
                        </v-col>
                        <v-col cols="2"
text-xs-right>
                          <v-chip
v-if="option.count > 0"
                                  small
>
                            {{ option.count }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-row style="margin:0;">
                    <v-col
v-for="option in facet.data"
                           cols="12"
:key="option.id" style="margin:0;"
>
                      <v-row
justify="space-between"
                             align="center"
style="margin:0;"
>
                        <v-col cols="10">
                          <v-switch
                            v-model="option.selected"
                            :label="option.description"
                            :title="option.description"
                            hide-details
                            @click="AddRemoveFilterOption(option,facet)"
                          />
                        </v-col>
                        <v-col cols="2"
text-xs-right>
                          <v-chip
v-if="option.count > 0"
                                  small
>
                            {{ option.count }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
              <v-col cols="12">
                <v-divider />
                <v-row style="margin:0;">
                  <v-col cols="12">
                    Create peer group from funds with similar sector allocations.
                    This will look for funds whose top sectors (using the setting below)
                    that have sector allocations within +- a certain threshold (Plus/Minus range below) of this fund.
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    style="padding:8px;"
                  >
                    <v-switch
                      v-model="criteria.similar_sectors"
                      label="Enable similar sectors filter"
                      title="option.description"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    style="padding:8px;"
                  >
                    <v-text-field
                      v-model="criteria.search_by_similar_allocation"
                      style="max-width:150px;"
                      label="Enter +/- % Range"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    style="padding:8px;"
                  >
                    <v-text-field
                      v-model="criteria.top_sectors_total"
                      style="max-width:150px;"
                      label="% of the funds top sectors that must match the range"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-btn
              text
              small
              color="primary"
              @click="show_chart=!show_chart"
            >
              <span v-if="show_chart">Show List of Funds</span>
              <span v-else>Show Chart</span>
            </v-btn>
          </v-col>
          <v-col
            v-show="show_chart"
            id="peer-group-chart"
            cols="12"
          />
          <v-col v-show="!show_chart">
            <v-data-table
              :headers="headers"
              :items="fund_results"
            >
              <template
                slot="item"
                slot-scope="props"
              >
              <tr>
                <td>{{ props.item.name }}</td>
                <td class="text-xs-right">
                  {{ props.item.risk }}
                </td>
                <td class="text-xs-right">
                  {{ props.item.reward }}
                </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import SearchMixin from './mixins/search_mixins.js'
import FilterMixin from './mixins/filter_mixins.js'
import FiltersDialog from './filters_dialog.vue'

export default {
  components: {
    'filters-dialog': FiltersDialog
  },
  mixins: [SearchMixin, FilterMixin],

  data: () => ({
    searching: false,
    results: [],
    show_chart: true,
    SearchFacets: [],
    chart_data: [],
    fund_results: [],
    selected_facet_values: [],
    criteria: { similar_sectors: false, top_sectors_total: 50, search_by_similar_allocation: 5 },
    selected_facets: { text_temp: null, keywords: null, proximity_miles: null, proximity_postal_code: null, selected_options: [] },
    headers: [
      {
        text: 'Fund',
        align: 'left',
        sortable: false,
        value: 'name'
      },
      { text: 'Risk', value: 'risk' },
      { text: 'Reward', value: 'reward' }
    ]
  }),

  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    }
  },

  watch: {
    'criteria.similar_sectors': function (val) {
      this.refresh_filters()
    },
    'criteria.top_sectors_total': function (val) {
      this.refresh_filters()
    },
    'criteria.search_by_similar_allocation': function (val) {
      this.refresh_filters()
    }
  },

  mounted () {
    // this.loadAsyncData();
    this.InitSearchFacets()
  },

  created () {

  },

  methods: {
    InitSearchFacets: function () {
      var qarray = []
      qarray.push(this.$store.state.classifications_promise)
      var that = this
      axios.all(qarray)
        .then(function () {
          var sdata = []
          var allowed = [2, 3, 4, 5, 6, 9, 10, 11, 16, 18, 24]
          var data = that.$store.state.classifications
          for (var i = 0; i < data.length; i++) {
            var q = data[i]
            if ($.inArray(q.id, allowed) < 0) {
              continue
            }
            sdata.push({
              id: q['id'],
              description: q['name'],
              count: 0,
              full_description: 'Fund Classification: ' + q['name'],
              filter_identifier: 'fund_classification',
              selected: false
            })
          }

          that.SearchFacets.push({
            identifier: 'fund_classification',
            title: 'Fund Classification',
            data: sdata,
            custom_data: []
          })

          that.SearchFacets.push({ identifier: 'turnover2',
            help: 'enter numbers in the fields to search by range.  For example entering 0 and 50 will return funds whose turnover is between 0 and 50%',
            custom_data: [],
            title: 'QoQ Turnover',
            type: 'number_range',
            from: null,
            to: null,
            data: [
              { id: 1, description: 'No turnover', count: 0, full_description: '', selected: false },
              { id: 2, description: '0.01% - 10%', count: 0, full_description: '', selected: false },
              { id: 3, description: '10.01% - 25%', count: 0, full_description: '', selected: false },
              { id: 4, description: '25.01% - 50%', count: 0, full_description: '', selected: false },
              { id: 5, description: '50.01% - 100%', count: 0, full_description: '', selected: false },
              { id: 6, description: 'Over  100%', count: 0, full_description: '', selected: false }] })

          that.SearchFacets.push({ identifier: 'percent_top10',
            title: 'Top 10 Holdings %',
            help: 'enter a number in each field or select one of the options below.  For example entering 0 and 30 will return funds whose top 10 holdings % is between 0 and 30%',
            type: 'number_range',
            from: null,
            to: null,
            custom_data: [],
            data: [
              { id: 1, description: '0 - 10%', count: 0, full_description: '', selected: false },
              { id: 2, description: '10% - 20%', count: 0, full_description: '', selected: false },
              { id: 3, description: '20% - 30%', count: 0, full_description: '', selected: false },
              { id: 4, description: '30% - 40%', count: 0, full_description: '', selected: false },
              { id: 5, description: '40% - 50%', count: 0, full_description: '', selected: false },
              { id: 6, description: '50% - 60%', count: 0, full_description: '', selected: false },
              { id: 7, description: '60% - 70%', count: 0, full_description: '', selected: false },
              { id: 8, description: '70% - 80%', count: 0, full_description: '', selected: false },
              { id: 9, description: '80% and up', count: 0, full_description: '', selected: false }
            ] })

          that.SearchFacets.push({ identifier: 'holdings',
            help: 'enter a number in each field or select one of the options below.  For example, entering 0 and 15 will return funds that have between 0 and 15 holdings.',
            title: '# of Holdings',
            type: 'number_range',
            from: null,
            to: null,
            custom_data: [],
            data: [
              { id: 1, description: '1 - 10', count: 0, full_description: '', selected: false },
              { id: 2, description: '11 - 25', count: 0, full_description: '', selected: false },
              { id: 3, description: '26 - 50', count: 0, full_description: '', selected: false },
              { id: 4, description: '51 - 100', count: 0, full_description: '', selected: false },
              { id: 5, description: '100 - 1,000', count: 0, full_description: '', selected: false },
              { id: 6, description: 'Over  1,000', count: 0, full_description: '', selected: false }] })
          that.SearchFacets.push({ identifier: 'mv',
            title: '13F AUM',
            type: 'number_range',
            from: null,
            to: null,
            custom_data: [],
            data: [
              { id: 1, description: '$1 - $100 million', count: 0, full_description: '' },
              { id: 2, description: '$100 million - $500 million', count: 0, full_description: '', selected: false },
              { id: 3, description: '$500 million - $1 billion', count: 0, full_description: '', selected: false },
              { id: 4, description: '$1 billion - $5 billion', count: 0, full_description: '', selected: false },
              { id: 5, description: '$5 billion - $20 billion', count: 0, full_description: '', selected: false },
              { id: 6, description: '$20 billion - $50 billion', count: 0, full_description: '', selected: false },
              { id: 7, description: '$50 billion - $200 billion', count: 0, full_description: '', selected: false },
              { id: 8, description: 'Over $200 billion', count: 0, full_description: '', selected: false }] })

          for (var i = 0; i < that.SearchFacets.length; i++) {
            var sf = that.SearchFacets[i]
            sf.expanded = true
            for (var j = 0; j < sf.data.length; j++) {
              var d = sf.data[j]
              d.full_description = sf.title + ': ' + d.description
              d.filter_identifier = sf.identifier
            }
          }
          that.build_default_peer_group()
          // that.loadAsyncData();
          //  that.setup_search_facets();
        })
    },
    build_search_url: function () {
      return '/dashboard/schedule13_search_query'
    },
    AddRemoveFilterOption: function (option, filter) {
      if (option.selected) {
        // option.selected=false;
        var i = this.selected_facet_values.indexOf(option)
        this.selected_facet_values.splice(i, 1)
        if (option.custom) {
          var i = filter.custom_data.indexOf(option)
          filter.custom_data.splice(i, 1)
        }
        filter.selected_count -= 1
      } else {
        this.selected_facet_values.push(option)
        //  option.selected=true;
        if (!filter.selected_count) { filter.selected_count = 1 } else { filter.selected_count += 1 }
      }
      this.$nextTick(() => {
        this.refresh_filters()
      })
    },
    format_chart_data: function (data, s) {
      //  var sdata=data.data[0];
      var drilldown_data = []
      // var details=sdata.details;
      var scatterplotx_measure = null
      var scatterploty_measure = null
      for (var i = 0; i < data.measures.length; i++) {
        var measure = data.measures[i]
        var sdata = measure.data[0]
        var details = sdata.details

        if (!scatterplotx_measure) { scatterplotx_measure = { index: i + 0, measure: measure } } else { scatterploty_measure = { index: i + 0, measure: measure } }
      }
      if (scatterplotx_measure && scatterploty_measure) {
        // swap
        // var temp=scatterplotx_measure;
        // scatterplotx_measure=scatterploty_measure;
        // scatterploty_measure=temp;
        var detailsx = scatterplotx_measure.measure.data[0].details
        var detailsy = scatterploty_measure.measure.data[0].details
        var drill = { // "id":quarter.quarter_date+s.name,
          type: 'scatter',
          name: scatterplotx_measure.measure.data[0].quarter_description + ' - ' +
                        scatterplotx_measure.measure.measure.series_label +
                        '(x) vs ' + scatterploty_measure.measure.measure.series_label + '(y)',
          turboThreshold: 0,
          data: [] }
        var current_filer_id = window.whalewisdom.Filer.filer_id
        for (var k = 0; k < detailsx.length; k++) {
          var detail_entry = detailsx[k]
          var x = detail_entry.measures[0]
          var existing_entry = detailsy.find(function (element) {
            return element.name == detail_entry.name
          })
          var y = null
          if (existing_entry) {
            y = existing_entry.measures[0]
          }

          // var y=detail_entry.measures[scatterploty_measure.index];
          var rec = { name: detail_entry.name,
            x: x,
            y: y,
            measure: scatterplotx_measure,
            measurey: scatterploty_measure }
          if (x && y) {
            if (detail_entry.filer_id == current_filer_id) {
              rec.marker = { fillColor: '#BF0B23', radius: 10 }
            }
          }

          drill.data.push(rec)
        }

        var newdrill = []
        for (var k = 0; k < drill.data.length; k++) {
          var entry = drill.data[k]

          if (entry.x && entry.y) { newdrill.push(entry) }
        }
        drill.data = newdrill

        drilldown_data.push(drill)
        var line = this.add_regression_line(drill.data)
        drilldown_data.push(line)
      }
      return drilldown_data
    },
    draw_chart: function () {
      var that = this

      Highcharts.chart('peer-group-chart', {
        credits: {
          enabled: false
        },
        exporting: {
          chartOptions: { // specific options for the exported image
            plotOptions: {
              series: {
                dataLabels: {
                  enabled: true
                }
              }
            }
          },
          fallbackToExportServer: false
        },
        chart: {
          // type:'bar',
          zoomType: 'x'
        },
        xAxis: {
          title: {
            text: 'Risk'
          },
          labels: {
            formatter: function () {
              return numbro(this.value / 100.0).format('0.000%')
            }
          }
        },
        yAxis: {
          title: {
            text: 'Reward'
          },
          labels: {
            formatter: function () {
              return numbro(this.value / 100.0).format('0.000%')
            }
          }
        },
        title: {
          text: 'Risk/Reward for Peer Group with Regression Line (max 100 funds)'
        },
        tooltip: {
          //  shared: true,
          crosshairs: [true, true],
          formatter: function () {
            return that.aggTooltipFormatter(this)
          }
        },
        series: this.chart_data
      })

      this.fund_results = []
      if (this.chart_data.length > 0) {
        for (var i = 0; i < this.chart_data[0].data.length; i++) {
          var item = this.chart_data[0].data[i]
          this.fund_results.push({ name: item.name,
            risk: item.x,
            reward: item.y })
        }
      }
    },
    add_regression_line: function (series_data) {
      // drill.data.push({name:detail_entry.name,x:x,y:y});
      if (!series_data || series_data.length == 0) { return }
      var x1y1 = [series_data[0].x, 0]
      var x2y2 = [series_data[0].x, 0]

      var x = []
      var y = []
      for (var i = 0; i < series_data.length; i++) {
        var entry = series_data[i]
        if (entry.x < x1y1[0]) { x1y1[0] = entry.x }
        if (entry.x > x2y2[0]) { x2y2[0] = entry.x }
        x.push(entry.x)
        y.push(entry.y)
      }
      var lr = this.linearRegression(y, x)

      x1y1[1] = lr.slope * x1y1[0] + lr.intercept
      x2y2[1] = lr.slope * x2y2[0] + lr.intercept
      var line = {
        type: 'line',
        name: 'Regression Line',
        data: [x1y1, x2y2],
        marker: {
          enabled: false
        },
        states: {
          hover: {
            lineWidth: 0
          }
        },
        enableMouseTracking: false
      }
      return line
    },
    linearRegression: function (y, x) {
      // http://trentrichardson.com/2010/04/06/compute-linear-regressions-in-javascript/
      var lr = {}
      var n = y.length
      var sum_x = 0
      var sum_y = 0
      var sum_xy = 0
      var sum_xx = 0
      var sum_yy = 0

      for (var i = 0; i < y.length; i++) {
        sum_x += x[i]
        sum_y += y[i]
        sum_xy += (x[i] * y[i])
        sum_xx += (x[i] * x[i])
        sum_yy += (y[i] * y[i])
      }

      lr['slope'] = (n * sum_xy - sum_x * sum_y) / (n * sum_xx - sum_x * sum_x)
      lr['intercept'] = (sum_y - lr.slope * sum_x) / n
      lr['r2'] = Math.pow((n * sum_xy - sum_x * sum_y) / Math.sqrt((n * sum_xx - sum_x * sum_x) * (n * sum_yy - sum_y * sum_y)), 2)

      return lr
    },
    aggTooltipFormatter: function (tooltip) {
      var tip = ''

      var point = tooltip.point
      if (!point && tooltip.points && tooltip.points.length > 0) {
        point = tooltip.points[0]
      }
      if (!point) {
        return ''
      }
      if (point.name) { tip = point.name + '<br/>' } else { tip = point.key + '<br/>' }
      if (tooltip.points && tooltip.points.length > 0) {
        for (var i = 0; i < tooltip.points.length; i++) {
          var p = tooltip.points[i]
          tip += this.FormatPoint(p, tooltip, i) + '<br/>'
        }
      } else {
        tip += this.FormatPoint(point, tooltip)
      }

      return tip
    },
    FormatPoint: function (point, tooltip, point_index) {
      var tip = ''
      var measure = null
      var series = point.series
      if (point.point) { measure = point.point.measure } else { measure = point.measure }
      if (point.measurey) {
        var value = this.format_value(point.x, measure.measure.measure)
        var valuey = this.format_value(point.y, point.measurey.measure.measure)
        tip += measure.measure.measure.series_label + ': <b>' + value + '</b><br/>'
        tip += point.measurey.measure.measure.series_label + ': <b>' + valuey + '</b><br/>'
      } else {
        var value = this.format_value(point.y, measure.measure)
        tip += series.name + ': <b>' + value + '</b><br/>'
      }

      return tip
    },
    format_value: function (value, measure) {
      if (!measure) { return value }
      var display = ''
      if (measure.format == 'numeric') {
        display = numbro(value).format('0.000a')
      } else if (measure.format == 'currency') {
        display = numbro(value).formatCurrency('($ 0.0a)')
      } else if (measure.format == 'percentage') {
        display = numbro(value / 100.0).format('0.000%')
      } else {
        display = value
      }
      return display
    },
    AddRemoveFilterOptionPeer: function (option, filter) {
      if (option.selected) {
        option.selected = false
        var i = this.selected_facet_values.indexOf(option)
        this.selected_facet_values.splice(i, 1)
        if (option.custom) {
          var i = filter.custom_data.indexOf(option)
          filter.custom_data.splice(i, 1)
        }
        filter.selected_count -= 1
      } else {
        this.selected_facet_values.push(option)
        option.selected = true
        if (!filter.selected_count) { filter.selected_count = 1 } else { filter.selected_count += 1 }
      }

      // this.refresh_filters();
    },
    build_default_peer_group: function () {
      // use similar mc, turnover, holdings?
      if (this.selected_facet_values) {

      } else { this.selected_facet_values = [] }
      // get turnover2 amount
      var turnover = parseFloat($('#filer-turnover2').html())
      // get AUM amount
      var aum = parseInt($('#filer-mv').html())
      // get # holdings
      var holdings = parseInt($('#filer-holdings').html())
      // get top 10 holdings concentration
      var top10 = parseFloat($('#filer-top-10').html())
      var facet = this.find_facet('percent_top10')
      if (top10 <= 10) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 1), facet)
      } else if (top10 <= 20) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 2), facet)
      } else if (top10 <= 30) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 3), facet)
      } else if (top10 <= 40) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 4), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 5), facet)
      } else if (top10 <= 50) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 5), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 6), facet)
      } else if (top10 <= 60) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 6), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 7), facet)
      } else if (top10 <= 70) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 7), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 8), facet)
      } else if (top10 <= 80) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 8), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 9), facet)
      } else {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 9), facet)
      }
      facet = this.find_facet('turnover2')
      if (turnover > 50) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 5), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 6), facet)
      } else if (turnover > 25) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 4), facet)
      } else if (turnover > 10) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 3), facet)
      } else {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 2), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 1), facet)
      }

      facet = this.find_facet('holdings')
      if (holdings <= 10) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 1), facet)
      } else if (holdings <= 25) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 2), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 3), facet)
      } else if (holdings <= 50) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 2), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 3), facet)
      } else if (holdings <= 100) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 4), facet)
      } else if (holdings <= 1000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 5), facet)
      } else {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 6), facet)
      }

      facet = this.find_facet('mv')
      if (aum <= 100000000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 1), facet)
      } else if (aum <= 500000000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 2), facet)
      } else if (aum <= 1000000000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 3), facet)
      } else if (aum <= 5000000000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 4), facet)
      } else if (aum <= 20000000000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 5), facet)
      } else if (aum <= 50000000000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 6), facet)
      } else if (aum <= 200000000000) {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 7), facet)
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 6), facet)
      } else {
        this.AddRemoveFilterOptionPeer(this.find_facet_option(facet, 8), facet)
      }
      this.refresh_filters()
    },
    ToggleSimilarSectors: function () {
      this.criteria.similar_sectors = !this.criteria.similar_sectors
      this.refresh_filters()
    },
    find_facet: function (identifier) {
      var measure = null
      for (var i = 0; i < this.SearchFacets.length; i++) {
        var obj = this.SearchFacets[i]
        if (obj.identifier == identifier) {
          measure = obj
          break
        }
      }

      return measure
    },

    find_facet_option: function (facet, id) {
      var found = null
      for (var i = 0; i < facet.data.length; i++) {
        var obj = facet.data[i]
        if (obj.id == id) {
          found = obj
          break
        }
      }
      return found
    },
    build_search_criteria: function () {
      var c = { similar_sectors: this.criteria.similar_sectors,
        top_sectors_total: this.criteria.top_sectors_total,
        search_by_similar_allocation: this.criteria.search_by_similar_allocation }
      for (var i = 0; i < this.selected_facet_values.length; i++) {
        var option = this.selected_facet_values[i]
        if (!c[option.filter_identifier]) { c[option.filter_identifier] = [] }
        c[option.filter_identifier].push('' + option.id)
      }

      return c
    },
    refresh_filters: function () {
      if (this.searching) { return }
      var that = this
      that.current_filer_count = ''
      that.searching = true
      that.ErrorMessage = null
      var criteria = that.build_search_criteria()
      criteria.filer_id = window.whalewisdom.Filer.filer_id
      // if (that.criteria.similar_sectors)
      //    criteria.search_by_similar_allocation=5;
       var token=document.getElementsByName('csrf-token')[0].content;
      axios.post('/dashboard/risk_reward_query/', criteria,{  headers: {'X-CSRF-Token': token},})
        .then(response => {
          that.searching = false
          var data = response.data
          that.results = data
          that.current_filer_count = data.records
          that.update_facet_counts()
          that.chart_data = that.format_chart_data(data)

          that.draw_chart()
          // got to update facet counts as well?
          // convert?
          // $timeout(that.update_scrollbar);
        })
        .catch(error => {
          that.searching = false
          // var data=response.data;
          that.ErrorMessage = error
        })
        .then(() => (this.loading = false))
    }
  }
}

</script>

<style lang="scss">
    .input-group label{font-size:14px !important;}
     .application--wrap{min-height:0 !important;}
</style>
